import React from "react";

const Footer = () => {
  return <div>Footer place...</div>;
};

export default Footer;
